import * as React from "react";
import { useContext, useMemo, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { useTextDomainContext } from "@/app/providers";
import { arrayOf, shape, string, object, func } from "prop-types";
import { IoIosArrowDown } from "react-icons/io";

export const GridToolbarDropdown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const open = Boolean(anchorEl);

  // Use props directly with fallbacks and useMemo for derived state
  const options = useMemo(() => {
    return props.options || [];
  }, [props.options]);

  const selectedOption = useMemo(() => {
    if (props.selectedOption) {
      return props.selectedOption;
    } else if (options.length > 0) {
      return options[0];
    } else {
      return {
        value: "",
        label: gettext("Select"),
      };
    }
  }, [props.selectedOption, options, gettext]);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (obj: any) => {
    if (typeof props.onChange === "function") {
      props.onChange(obj);
    }
    handleClose();
  };

  return (
    <>
      <Button
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<IoIosArrowDown size={14} />}
        sx={{
          ml: 1,
          color: "grey.600",
          fontWeight: 400,
        }}
      >
        {selectedOption.label}
      </Button>

      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            "aria-labelledby": "fade-button",
          },
        }}
        slots={{
          transition: Fade,
        }}
      >
        {options.map((obj: any) => (
          <MenuItem
            key={obj.value}
            onClick={() => handleSelect(obj)}
            sx={{
              fontSize: "0.875rem",
              color: "grey.600",
              fontWeight: 300,
            }}
          >
            {obj.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

GridToolbarDropdown.propTypes = {
  options: arrayOf(
    shape({
      value: string.isRequired,
      label: string.isRequired,
    }),
  ),
  data: arrayOf(object),
  onChange: func,
  selectedOption: shape({
    value: string.isRequired,
    label: string.isRequired,
  }),
};
